import React from "react";
import {
  CCard,
  CCardHeader,
  CCardBody,
  CNavLink,
  CRow,
  CCol,
  CListGroup,
  CListGroupItem,
} from "@coreui/react-pro";
import { useNavigate } from "react-router-dom";
import { GoogleMapsComponent } from "./Map";
import { useHotelData } from "./Map";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";

const MapHotels = () => {
  const navigate = useNavigate();
  const { hotels } = useHotelData();

  const handleHotelClick = (hotel) => {
    if (hotel.Shower_Room_Availability) {
      navigate(`/book-shower/${hotel.Hotel_Description}`);
    } else {
      toast.error("The hotel is currently unavailable");
    }
  };

  return (
    <>
      <CRow>
        <CCol xs="12" md="6">
          <CCard>
            <CCardHeader>Hotel Map</CCardHeader>
            <CCardBody>
              <GoogleMapsComponent />
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs="12" md="6">
          <CCard>
            <CCardHeader>Hotel List</CCardHeader>
            <CCardBody>
              <CListGroup>
                {Array.isArray(hotels) &&
                  hotels.map((hotel, index) => (
                    <CListGroupItem
                      key={hotel.Hotel_ID.toString()}
                      onClick={() => handleHotelClick(hotel)}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <h5
                        style={{
                          color: hotel.Shower_Room_Availability
                            ? "black"
                            : "gray",
                        }}
                      >
                        {hotel.Hotel_Description}
                      </h5>
                    </CListGroupItem>
                  ))}
              </CListGroup>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  );
};

export default MapHotels;
